module.exports = __webpack_public_path__ + "static/img/11.1c771a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/zh/11.png
// module id = BMUs
// module chunks = 0